module.exports = __webpack_public_path__ + "img/DE03472.0fa8ad49.png";